module.exports = __webpack_public_path__ + "static/media/iron_steel_worker.c3dabe40.svg";